import '../assets/MazPhoneNumberInput.css';
import { computed as f, defineComponent as ke, defineAsyncComponent as H, ref as h, getCurrentInstance as Se, onMounted as Ee, useSlots as Me, openBlock as v, createElementBlock as k, normalizeClass as E, normalizeStyle as ae, createElementVNode as q, createCommentVNode as y, renderSlot as Y, createBlock as D, unref as V, resolveDynamicComponent as Be, withDirectives as De, mergeProps as $e, toHandlers as Ue, vModelDynamic as Oe, createTextVNode as Ce, toDisplayString as X, withModifiers as pe, withCtx as fe, createVNode as Z, useCssVars as Re, onBeforeMount as He, Transition as qe, Fragment as Le, renderList as We, nextTick as x, reactive as Ye, watch as ce } from "vue";
import { isSupportedCountry as je, getCountryCallingCode as Ve, getExampleNumber as Ge, getCountries as Qe, parsePhoneNumberFromString as Je, AsYouType as Xe } from "libphonenumber-js";
function Ne(u) {
  return !!u;
}
const Pe = ({
  componentName: u,
  instance: s,
  providedId: a
}) => f(() => a ?? `${u}-${s == null ? void 0 : s.uid}`), Ze = {
  countrySelector: {
    placeholder: "Country code",
    error: "Choose country",
    searchPlaceholder: "Search the country"
  },
  phoneInput: {
    placeholder: "Phone number",
    example: "Example:"
  }
};
function Ke(u) {
  return [...u].map((s) => {
    const a = s.codePointAt(0);
    return a ? a % 32 + 127461 : void 0;
  }).filter(Ne).map((s) => String.fromCodePoint(s)).join("");
}
let ge, Fe;
function xe(u, s, a) {
  return a != null && a[s] ? a[s] : ((Fe !== u || !ge) && (Fe = u, ge = new Intl.DisplayNames([u], { type: "region" })), ge.of(s));
}
const _e = /^[\d ().-]+$/, eo = /^[^a-z]+$/i;
let we;
async function oo() {
  const { default: u } = await import("./examples.mobile.json-zD8w3Qhl.mjs");
  return we = u, we;
}
function to(u, s) {
  return Ve(u) === Ve(s);
}
function lo(u) {
  var s;
  try {
    return u ? (s = Ge(u, we)) == null ? void 0 : s.formatNational() : void 0;
  } catch (a) {
    console.error(`[maz-ui](MazPhoneNumberInput) ${a}`);
  }
}
function no(u) {
  if (!u)
    return "";
  const s = eo.test(u), a = _e.test(u);
  return !s && !a ? u.replaceAll(/[^\d.]/g, "") : u;
}
function ao(u, s) {
  const a = [], L = Qe();
  u = u ?? Te().browserLocale ?? "en-US";
  for (const $ of L) {
    const W = xe(u, $, s);
    if (W)
      try {
        const U = Ve($);
        a.push({
          iso2: $,
          dialCode: U,
          name: W
        });
      } catch (U) {
        console.error(`[MazPhoneNumberInput](getCountryCallingCode) ${U}`);
      }
  }
  return a;
}
function Te() {
  if (typeof window > "u")
    return {};
  const u = window.navigator.language;
  if (!u)
    return {};
  let s = u.slice(3, 7).toUpperCase();
  return s === "" && (s = u.slice(0, 2).toUpperCase()), s === "EN" && (s = "US"), s === "JA" && (s = "JP"), { locale: s, browserLocale: u };
}
function ro(u) {
  try {
    const s = je(u);
    return s || (console.error(`[maz-ui](MazPhoneNumberInput) The code country "${u}" is not available`), !1);
  } catch (s) {
    return console.error(`[maz-ui](MazPhoneNumberInput) ${s}`), !1;
  }
}
const uo = ({
  phoneNumber: u,
  countryCode: s
}) => {
  try {
    if (!u)
      return {
        isValid: !1,
        countryCode: s
      };
    const a = Je(u, s);
    return {
      isValid: (a == null ? void 0 : a.isValid()) ?? !1,
      isPossible: a == null ? void 0 : a.isPossible(),
      countryCode: a == null ? void 0 : a.country,
      countryCallingCode: a == null ? void 0 : a.countryCallingCode,
      nationalNumber: a == null ? void 0 : a.nationalNumber,
      type: a == null ? void 0 : a.getType(),
      formatInternational: a == null ? void 0 : a.formatInternational(),
      formatNational: a == null ? void 0 : a.formatNational(),
      uri: a == null ? void 0 : a.getURI(),
      e164: a == null ? void 0 : a.format("E.164"),
      rfc3966: a == null ? void 0 : a.format("RFC3966")
    };
  } catch (a) {
    throw new Error(`[MazPhoneNumberInput](getResultsFromPhoneNumber) ${a}`);
  }
};
function so(u, s) {
  try {
    return s ? new Xe(u).input(s) : void 0;
  } catch (a) {
    throw new Error(`[MazPhoneNumberInput](getAsYouTypeFormat) ${a}`);
  }
}
async function io() {
  try {
    const u = await fetch("https://ipwho.is"), { country_code: s } = await u.json();
    return s;
  } catch (u) {
    throw new Error(`[MazPhoneNumberInput](fetchCountryCode) ${u}`);
  }
}
function co() {
  return {
    fetchCountryCode: io,
    getAsYouTypeFormat: so,
    getResultsFromPhoneNumber: uo,
    loadPhoneNumberExamplesFile: oo,
    getPhoneNumberExample: lo,
    sanitizePhoneNumber: no,
    getCountriesList: ao,
    browserLocale: Te,
    isSameCountryCallingCode: to
  };
}
function po(u, s) {
  let a;
  return function(...L) {
    clearTimeout(a), a = setTimeout(() => {
      u.apply(this, L);
    }, s);
  };
}
const fo = {
  key: 0,
  class: "m-input-wrapper-left"
}, mo = { class: "m-input-wrapper-input" }, yo = ["id", "type", "name", "inputmode", "placeholder", "aria-label", "disabled", "readonly", "required"], vo = { key: 0 }, ho = {
  key: 1,
  class: "m-input-wrapper-right"
}, bo = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "MazInput",
  props: {
    style: { default: void 0 },
    class: { default: void 0 },
    modelValue: { type: [String, Number, null, Boolean], default: void 0 },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    name: { default: void 0 },
    color: { default: "primary" },
    type: { default: "text" },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    id: { default: void 0 },
    error: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    warning: { type: Boolean, default: !1 },
    hint: { default: void 0 },
    inputClasses: { default: void 0 },
    noBorder: { type: Boolean, default: !1 },
    noRadius: { type: Boolean, default: !1 },
    inputmode: { default: "text" },
    size: { default: "md" },
    debounce: { type: [Boolean, Number], default: !1 },
    debounceDelay: { default: 500 },
    validButton: { type: Boolean, default: !1 },
    validButtonLoading: { type: Boolean, default: !1 },
    autoFocus: { type: Boolean, default: !1 },
    borderActive: { type: Boolean, default: !1 },
    leftIcon: { default: void 0 },
    rightIcon: { default: void 0 },
    roundedSize: { default: void 0 }
  },
  emits: ["update:model-value", "focus", "blur", "click", "change"],
  setup(u, { emit: s }) {
    const a = H(() => import("./MazBtn-DOaxPecG.mjs")), L = H(() => import("./MazIcon-Cxrv3_OK.mjs")), $ = H(() => import("./eye-slash-tjfxO0LK.mjs")), W = H(() => import("./eye-DqO_Jx56.mjs")), U = H(() => import("./check-7UA4j2f2.mjs")), t = u, P = s, A = h(!1), m = h(!1), c = h(), re = Se(), ue = Pe({
      componentName: "MazInput",
      instance: re,
      providedId: t.id
    });
    Ee(() => {
      var l;
      t.autoFocus && ((l = c.value) == null || l.focus());
    });
    const j = f(() => t.type === "password"), K = f(() => A.value ? "text" : t.type), S = f(() => {
      if (!t.noBorder) {
        if (t.error)
          return "maz-border-danger";
        if (t.success)
          return "maz-border-success";
        if (t.warning)
          return "maz-border-warning";
        if (m.value || t.borderActive) {
          if (t.color === "black")
            return "maz-border-black";
          if (t.color === "danger")
            return "maz-border-danger";
          if (t.color === "info")
            return "maz-border-info";
          if (t.color === "primary")
            return "maz-border-primary";
          if (t.color === "secondary")
            return "maz-border-secondary";
          if (t.color === "success")
            return "maz-border-success";
          if (t.color === "warning")
            return "maz-border-warning";
          if (t.color === "white")
            return "maz-border-white";
        }
        return "--default-border";
      }
    }), N = Me(), O = f(() => {
      const { required: l, placeholder: g } = t;
      if (g)
        return l ? `${g} *` : g;
    }), R = f(() => M.value !== void 0 && M.value !== ""), T = po(
      (l) => {
        M.value = l;
      },
      typeof t.debounce == "number" ? t.debounce : t.debounceDelay ?? 500
    ), M = f({
      get: () => t.modelValue,
      set: (l) => {
        if (t.debounce)
          return T(l);
        P("update:model-value", l);
      }
    }), ee = f(() => (!!t.label || !!t.hint) && (m.value || !!R.value || !!t.placeholder || ["date", "month", "week"].includes(t.type))), oe = f(() => !!t.label || !!t.hint);
    function w() {
      return !!N["right-icon"] || j.value || !!N["valid-button"] || t.validButton || !!t.rightIcon;
    }
    function G() {
      return !!N["left-icon"] || !!t.leftIcon;
    }
    function Q(l) {
      P("focus", l), m.value = !0;
    }
    function b(l) {
      P("blur", l), m.value = !1;
    }
    function B(l) {
      return P("change", l);
    }
    return (l, g) => (v(), k(
      "div",
      {
        class: E(["m-input", [
          {
            "--is-focused": m.value || l.borderActive,
            "--should-up": ee.value,
            "--has-label": oe.value,
            "--is-disabled": l.disabled,
            "--is-readonly": l.readonly,
            "--has-z-2": l.error || l.warning || l.success,
            "--has-state": l.error || l.warning || l.success
          },
          t.class,
          `--${l.color}`,
          `--${l.size}`
        ]]),
        style: ae(l.style)
      },
      [
        q(
          "div",
          {
            class: E(["m-input-wrapper", [
              l.inputClasses,
              S.value,
              l.roundedSize ? `--rounded-${l.roundedSize}` : { "maz-rounded": !l.noRadius }
            ]])
          },
          [
            G() ? (v(), k("div", fo, [
              y(`
          @slot left-icon - The icon to display on the left of the input
        `),
              l.$slots["left-icon"] || l.leftIcon ? Y(l.$slots, "left-icon", { key: 0 }, () => [
                typeof l.leftIcon == "string" ? (v(), D(V(L), {
                  key: 0,
                  name: l.leftIcon,
                  class: "maz-text-xl maz-text-muted"
                }, null, 8, ["name"])) : l.leftIcon ? (v(), D(Be(l.leftIcon), {
                  key: 1,
                  class: "maz-text-xl maz-text-muted"
                })) : y("v-if", !0)
              ], !0) : y("v-if", !0)
            ])) : y("v-if", !0),
            q("div", mo, [
              De(q("input", $e({
                id: V(ue),
                ref_key: "input",
                ref: c,
                "onUpdate:modelValue": g[0] || (g[0] = (z) => M.value = z),
                type: K.value,
                name: l.name
              }, l.$attrs, {
                inputmode: l.inputmode,
                placeholder: O.value,
                "aria-label": l.label || l.placeholder,
                disabled: l.disabled,
                readonly: l.readonly,
                required: l.required,
                class: "m-input-input"
              }, Ue({
                blur: b,
                focus: Q,
                change: B
              }, !0), {
                onClick: g[1] || (g[1] = (z) => l.$emit("click", z))
              }), null, 16, yo), [
                [Oe, M.value]
              ]),
              l.label || l.hint ? (v(), k(
                "span",
                {
                  key: 0,
                  ref: "label",
                  class: E(["m-input-label", [
                    {
                      "maz-text-danger-600": l.error,
                      "maz-text-success-600": l.success,
                      "maz-text-warning-600": l.warning
                    }
                  ]])
                },
                [
                  Ce(
                    X(l.hint || l.label) + " ",
                    1
                    /* TEXT */
                  ),
                  l.required ? (v(), k("sup", vo, "*")) : y("v-if", !0)
                ],
                2
                /* CLASS */
              )) : y("v-if", !0)
            ]),
            w() ? (v(), k("div", ho, [
              y(`
          @slot right-icon - The icon to display on the right of the input
        `),
              l.$slots["right-icon"] || l.rightIcon ? Y(l.$slots, "right-icon", { key: 0 }, () => [
                typeof l.rightIcon == "string" ? (v(), D(V(L), {
                  key: 0,
                  name: l.rightIcon,
                  class: "maz-text-xl maz-text-muted"
                }, null, 8, ["name"])) : l.rightIcon ? (v(), D(Be(l.rightIcon), {
                  key: 1,
                  class: "maz-text-xl maz-text-muted"
                })) : y("v-if", !0)
              ], !0) : y("v-if", !0),
              j.value ? (v(), D(V(a), {
                key: 1,
                color: "transparent",
                tabindex: "-1",
                size: "mini",
                onClick: g[2] || (g[2] = pe((z) => A.value = !A.value, ["stop"]))
              }, {
                default: fe(() => [
                  A.value ? (v(), D(V($), {
                    key: 0,
                    class: "maz-text-xl maz-text-muted"
                  })) : (v(), D(V(W), {
                    key: 1,
                    class: "maz-text-xl maz-text-muted"
                  }))
                ]),
                _: 1
                /* STABLE */
              })) : y("v-if", !0),
              y(`
          @slot valid-button - Replace the valid button by your own
        `),
              l.$slots["valid-button"] || l.validButton ? Y(l.$slots, "valid-button", { key: 2 }, () => [
                Z(V(a), {
                  color: "transparent",
                  disabled: l.disabled,
                  tabindex: "-1",
                  loading: l.validButtonLoading,
                  class: "m-input-valid-button",
                  size: "mini",
                  type: "submit"
                }, {
                  default: fe(() => [
                    Z(V(U), { class: "maz-text-2xl maz-text-normal" })
                  ]),
                  _: 1
                  /* STABLE */
                }, 8, ["disabled", "loading"])
              ], !0) : y("v-if", !0)
            ])) : y("v-if", !0)
          ],
          2
          /* CLASS */
        )
      ],
      6
      /* CLASS, STYLE */
    ));
  }
}), Ae = (u, s) => {
  const a = u.__vccOpts || u;
  for (const [L, $] of s)
    a[L] = $;
  return a;
}, Ie = /* @__PURE__ */ Ae(bo, [["__scopeId", "data-v-b6c84f7a"]]);
h("system");
h("system");
let ze = null;
function go(u, s) {
  ze && clearTimeout(ze), ze = setTimeout(u, s);
}
const zo = ["aria-label"], Co = { class: "m-select-list__no-results" }, Vo = {
  key: 2,
  class: "m-select-list__scroll-wrapper",
  tabindex: "-1"
}, wo = { class: "m-select-list-optgroup" }, Io = ["onClick"], ko = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "MazSelect",
  props: {
    style: { default: void 0 },
    class: { default: void 0 },
    id: { default: void 0 },
    modelValue: { type: [String, Number, null, Boolean, Array], default: void 0 },
    options: { default: void 0 },
    optionValueKey: { default: "value" },
    optionLabelKey: { default: "label" },
    optionInputValueKey: { default: "label" },
    listPosition: { default: "bottom left" },
    itemHeight: { default: void 0 },
    maxListHeight: { default: 240 },
    maxListWidth: { default: void 0 },
    size: { default: "md" },
    color: { default: "primary" },
    search: { type: Boolean },
    searchPlaceholder: { default: "Search in options" },
    open: { type: Boolean },
    multiple: { type: Boolean },
    required: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["close", "open", "blur", "focus", "change", "update:model-value", "selected-option"],
  setup(u, { emit: s }) {
    Re((e) => ({
      "39733c9a": j.value,
      "014b4cd9": re.value,
      56278181: ue.value
    }));
    const a = H(() => import("./MazCheckbox-BzLvnzJB.mjs")), L = H(() => import("./magnifying-glass-DZGg7953.mjs")), $ = H(() => import("./chevron-down-CzMH-gFW.mjs")), W = H(() => import("./no-symbol-QAqP9IlR.mjs")), U = Se(), t = u, P = s, A = h(!1), m = h(), c = f(
      () => ["black", "transparent", "white"].includes(t.color)
    ), re = f(
      () => c.value ? "var(--maz-color-black)" : `var(--maz-color-${t.color}-800)`
    ), ue = f(
      () => c.value ? "var(--maz-color-muted)" : `var(--maz-color-${t.color}-100)`
    ), j = f(
      () => c.value ? "var(--maz-color-muted)" : `var(--maz-color-${t.color}-200)`
    ), K = f(() => A.value || t.open), S = Pe({
      componentName: "MazSelect",
      instance: U,
      providedId: t.id
    });
    function N(e) {
      return {
        [t.optionValueKey]: e,
        [t.optionLabelKey]: e,
        [t.optionInputValueKey]: e
      };
    }
    function O(e) {
      return {
        ...e,
        [t.optionValueKey]: e[t.optionValueKey],
        [t.optionLabelKey]: e[t.optionLabelKey],
        [t.optionInputValueKey]: e[t.optionInputValueKey]
      };
    }
    const R = f(() => {
      var n;
      const e = [];
      if (!((n = t.options) != null && n.length))
        return [];
      for (const r of t.options)
        typeof r == "string" || typeof r == "number" || typeof r == "boolean" ? e.push(N(r)) : "options" in r && Array.isArray(r.options) ? e.push(
          { label: r.label, isOptGroup: !0 },
          ...r.options.map(
            (i) => typeof i == "string" || typeof i == "number" || typeof i == "boolean" ? N(i) : O(i)
          )
        ) : e.push(O(r));
      return e;
    }), T = f(
      () => {
        var e;
        return ((e = R.value) == null ? void 0 : e.filter((n) => t.multiple ? Array.isArray(t.modelValue) ? t.modelValue.includes(n[t.optionValueKey]) && !w(n[t.optionValueKey]) : !1 : t.modelValue === n[t.optionValueKey] && !w(n[t.optionValueKey]))) ?? [];
      }
    );
    He(() => {
      var e;
      (e = t.options) != null && e.length || console.warn("[maz-ui](MazSelect) you must provide options"), o();
    });
    const _ = h(), M = h(), ee = h(), oe = h(), w = (e) => e == null;
    function G(e) {
      var r;
      return (((r = T.value) == null ? void 0 : r.some(
        (i) => i[t.optionValueKey] === e[t.optionValueKey]
      )) ?? !1) && !w(e[t.optionValueKey]);
    }
    const Q = f(() => {
      var n;
      if (t.multiple && t.modelValue && Array.isArray(t.modelValue))
        return t.modelValue.map(
          (r) => {
            var i, p;
            return (p = (i = R.value) == null ? void 0 : i.find((C) => C[t.optionValueKey] === r)) == null ? void 0 : p[t.optionInputValueKey];
          }
        ).join(", ");
      const e = (n = R.value) == null ? void 0 : n.find(
        (r) => r[t.optionValueKey] === t.modelValue
      );
      return w(t.modelValue) || e == null ? void 0 : e[t.optionInputValueKey];
    }), b = f(
      () => t.listPosition.includes("bottom") ? "maz-slide" : "maz-slideinvert"
    ), B = h(""), l = h("");
    function g(e) {
      return e.normalize("NFD").replaceAll(/[\u0300-\u036F]/g, "").replaceAll(/[^\dA-Za-z\u0400-\u04FF]/g, "");
    }
    const z = (e, n) => n && e && g(e.toString().toLocaleLowerCase().trim()).includes(
      g(n.toLocaleLowerCase().trim())
    );
    function I(e) {
      var n;
      return e ? (n = R.value) == null ? void 0 : n.filter((r) => {
        const i = r[t.optionLabelKey], p = r[t.optionValueKey], C = r[t.optionInputValueKey];
        return z(i, e) || z(p, e) || z(C, e);
      }) : R.value;
    }
    const F = f(() => I(B.value)), te = async (e) => {
      var n;
      if (e && ("relatedTarget" in e && ((n = _.value) != null && n.contains(e.relatedTarget)) || e.type === "keydown"))
        return e.preventDefault();
      await x(), A.value = !1, m.value = 0, P("close", e);
    }, J = async (e) => {
      t.disabled || K.value || (e == null || e.preventDefault(), A.value = !0, await de(), P("focus", e), P("open", A.value));
    };
    function se() {
      var e, n;
      (n = ((e = M.value) == null ? void 0 : e.$el).querySelector("input")) == null || n.focus();
    }
    function me(e) {
      A.value ? te(e) : se();
    }
    function he(e) {
      var n, r;
      B.value = e, (r = ((n = ee.value) == null ? void 0 : n.$el).querySelector("input")) == null || r.focus();
    }
    function le(e) {
      var r;
      e === "Backspace" && l.value.length > 0 ? l.value = l.value.slice(0, -1) : l.value += e;
      const n = I(l.value);
      n != null && n.length && (m.value = (r = F.value) == null ? void 0 : r.findIndex(
        (i) => i[t.optionValueKey] === n[0][t.optionValueKey]
      ), typeof m.value == "number" && m.value >= 0 && de(m.value)), go(() => {
        l.value = "";
      }, 1e3);
    }
    const ye = (e) => {
      const n = e.key;
      /^[\dA-Za-z\u0400-\u04FF]$/.test(n) ? (e.preventDefault(), J(e), t.search ? he(n) : le(n)) : ve(e);
    }, ve = (e) => {
      const n = e.code, r = ["ArrowUp", "ArrowDown"].includes(n), i = ["Enter", "Space"].includes(n), p = n === "Escape" && K.value;
      r ? ie(e, m.value) : i ? be(e, m.value) : p && te();
    }, ie = (e, n) => {
      var p;
      e.preventDefault();
      const r = e.code;
      K.value || J(e);
      const i = (p = F.value) == null ? void 0 : p.length;
      i && (typeof n == "number" ? n === i - 1 && r === "ArrowDown" ? m.value = 0 : n === 0 && r === "ArrowUp" ? m.value = i - 1 : m.value = r === "ArrowDown" ? n + 1 : n - 1 : m.value = r === "ArrowDown" ? 0 : i - 1, de(m.value));
    }, be = (e, n) => {
      var i, p, C;
      if (e.preventDefault(), !K.value)
        return J(e);
      const r = n ? ((i = F.value) == null ? void 0 : i[n]) ?? ((p = F.value) == null ? void 0 : p[0]) : (C = F.value) == null ? void 0 : C[0];
      w(r) || d(r);
    };
    async function de(e) {
      var r, i;
      await x(), typeof e != "number" && o();
      const n = e ?? m.value;
      typeof n == "number" && n >= 0 && ((i = (r = oe.value) == null ? void 0 : r.querySelectorAll(".m-select-list-item")[n]) == null || i.scrollIntoView({
        behavior: "auto",
        block: "nearest",
        inline: "start"
      }));
    }
    function o(e) {
      var r;
      const n = (r = F.value) == null ? void 0 : r.findIndex((i) => {
        var p, C;
        return t.multiple && Array.isArray(t.modelValue) ? e ? e[t.optionValueKey] === i[t.optionValueKey] : [...t.modelValue].reverse()[0] === i[t.optionValueKey] : ((C = (p = T.value) == null ? void 0 : p[0]) == null ? void 0 : C[t.optionValueKey]) === i[t.optionValueKey];
      });
      m.value = n && n >= 0 ? n : 0;
    }
    const d = (e, n = !0) => {
      var C;
      n && !t.multiple && x(() => te()), B.value = "";
      const r = (C = T.value) == null ? void 0 : C.some(
        (ne) => ne[t.optionValueKey] === e[t.optionValueKey]
      );
      let i = T.value;
      r && t.multiple ? i = i == null ? void 0 : i.filter(
        (ne) => ne[t.optionValueKey] !== e[t.optionValueKey]
      ) : t.multiple ? i.push(e) : i = [e];
      const p = i.map((ne) => ne[t.optionValueKey]);
      P("update:model-value", t.multiple ? p : p[0]), P("selected-option", e), o(e), se();
    };
    return (e, n) => (v(), k(
      "div",
      {
        ref_key: "mazSelectElement",
        ref: _,
        class: E(["m-select", [{ "--is-open": K.value, "--disabled": e.disabled }, t.class, `--${e.size}`]]),
        style: ae(e.style),
        onBlurCapture: te
      },
      [
        Z(Ie, $e({
          id: V(S),
          ref_key: "mazInputComponent",
          ref: M,
          class: "m-select-input"
        }, e.$attrs, {
          required: e.required,
          "border-active": A.value,
          color: e.color,
          "model-value": Q.value,
          autocomplete: "off",
          size: e.size,
          disabled: e.disabled,
          onFocus: pe(J, ["prevent", "stop"]),
          onClick: pe(J, ["prevent", "stop"]),
          onChange: n[0] || (n[0] = (r) => P("change", r)),
          onKeydown: ye
        }), {
          "right-icon": fe(() => [
            q("button", {
              tabindex: "-1",
              type: "button",
              class: "m-select-input__toggle-button maz-custom",
              "aria-label": `${K.value ? "collapse" : "expand"} list of options`,
              onClick: pe(me, ["stop"])
            }, [
              Z(V($), { class: "m-select-chevron maz-text-xl" })
            ], 8, zo)
          ]),
          _: 1
          /* STABLE */
        }, 16, ["id", "required", "border-active", "color", "model-value", "size", "disabled"]),
        Z(qe, { name: b.value }, {
          default: fe(() => [
            K.value ? (v(), k(
              "div",
              {
                key: 0,
                ref_key: "optionsListElement",
                ref: oe,
                class: E(["m-select-list", {
                  "--top": e.listPosition.includes("top"),
                  "--left": e.listPosition.includes("left"),
                  "--right": e.listPosition.includes("right"),
                  "--bottom": e.listPosition.includes("bottom")
                }]),
                style: ae({
                  maxHeight: `${e.maxListHeight}px`,
                  maxWidth: `${e.maxListWidth}px`
                })
              },
              [
                e.search ? (v(), D(Ie, {
                  key: 0,
                  ref_key: "searchInputComponent",
                  ref: ee,
                  modelValue: B.value,
                  "onUpdate:modelValue": [
                    n[1] || (n[1] = (r) => B.value = r),
                    n[2] || (n[2] = (r) => m.value = 0)
                  ],
                  size: "sm",
                  color: e.color,
                  placeholder: e.searchPlaceholder,
                  name: "search",
                  autocomplete: "off",
                  tabindex: "-1",
                  class: "m-select-list__search-input maz-flex-none",
                  "left-icon": V(L),
                  onKeydown: ve
                }, null, 8, ["modelValue", "color", "placeholder", "left-icon"])) : y("v-if", !0),
                y(`
          @slot No results slot - Displayed when no results corresponding with search query
        `),
                !F.value || F.value.length <= 0 ? Y(e.$slots, "no-results", { key: 1 }, () => [
                  q("span", Co, [
                    Z(V(W), { class: "maz-h-6 maz-w-6 maz-text-normal" })
                  ])
                ], !0) : (v(), k("div", Vo, [
                  (v(!0), k(
                    Le,
                    null,
                    We(F.value, (r, i) => (v(), k(
                      Le,
                      { key: i },
                      [
                        y(`
              @slot Custom optgroup label
                @binding {String} label - the label of the optgroup
            `),
                        r.label && r.isOptGroup ? Y(e.$slots, "optgroup", {
                          key: 0,
                          label: r.label
                        }, () => [
                          q(
                            "span",
                            wo,
                            X(r.label),
                            1
                            /* TEXT */
                          )
                        ], !0) : (v(), k("button", {
                          key: 1,
                          tabindex: "-1",
                          type: "button",
                          class: E(["m-select-list-item maz-custom maz-flex-none", [
                            {
                              "--is-keyboard-selected": m.value === i,
                              "--is-selected": G(r),
                              "--is-none-value": w(r[e.optionValueKey])
                            }
                          ]]),
                          style: ae(e.itemHeight ? { minHeight: `${e.itemHeight}px` } : void 0),
                          onClick: pe((p) => d(r), ["prevent", "stop"])
                        }, [
                          e.multiple ? (v(), D(V(a), {
                            key: 0,
                            tabindex: "-1",
                            "model-value": G(r),
                            size: "sm",
                            color: e.color
                          }, null, 8, ["model-value", "color"])) : y("v-if", !0),
                          y(`
                @slot Custom option
                  @binding {Object} option - the option object
                  @binding {Boolean} is-selected - if the option is selected
              `),
                          Y(e.$slots, "default", {
                            option: r,
                            isSelected: G(r)
                          }, () => [
                            q(
                              "span",
                              null,
                              X(r[e.optionLabelKey]),
                              1
                              /* TEXT */
                            )
                          ], !0)
                        ], 14, Io))
                      ],
                      64
                      /* STABLE_FRAGMENT */
                    ))),
                    128
                    /* KEYED_FRAGMENT */
                  ))
                ]))
              ],
              6
              /* CLASS, STYLE */
            )) : y("v-if", !0)
          ]),
          _: 3
          /* FORWARDED */
        }, 8, ["name"])
      ],
      38
      /* CLASS, STYLE, NEED_HYDRATION */
    ));
  }
}), So = /* @__PURE__ */ Ae(ko, [["__scopeId", "data-v-6be8854d"]]), $o = ["id"], Po = {
  key: 0,
  class: "maz-text-lg"
}, Ao = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "MazPhoneNumberInput",
  props: {
    style: { default: void 0 },
    class: { default: void 0 },
    modelValue: { default: void 0 },
    defaultPhoneNumber: { default: void 0 },
    countryCode: { default: void 0 },
    defaultCountryCode: { default: void 0 },
    id: { default: void 0 },
    placeholder: { default: void 0 },
    preferredCountries: { default: void 0 },
    ignoredCountries: { default: void 0 },
    onlyCountries: { default: void 0 },
    translations: { default: void 0 },
    listPosition: { default: "bottom left" },
    color: { default: "primary" },
    size: { default: "md" },
    noFlags: { type: Boolean },
    disabled: { type: Boolean },
    noExample: { type: Boolean },
    noSearch: { type: Boolean },
    noUseBrowserLocale: { type: Boolean },
    fetchCountry: { type: Boolean },
    noCountrySelector: { type: Boolean },
    showCodeOnList: { type: Boolean },
    customCountriesList: { default: void 0 },
    noFormattingAsYouType: { type: Boolean },
    countryLocale: { default: void 0 },
    noValidationError: { type: Boolean },
    noValidationSuccess: { type: Boolean },
    success: { type: Boolean },
    error: { type: Boolean },
    countrySelectorDisplayName: { type: Boolean },
    countrySelectorWidth: { default: "9rem" }
  },
  emits: ["update", "data", "country-code", "update:model-value", "update:country-code"],
  setup(u, { emit: s }) {
    const {
      fetchCountryCode: a,
      browserLocale: L,
      getResultsFromPhoneNumber: $,
      getAsYouTypeFormat: W,
      getCountriesList: U,
      getPhoneNumberExample: t,
      sanitizePhoneNumber: P,
      loadPhoneNumberExamplesFile: A
    } = co(), m = s, c = u, re = Se(), ue = Pe({
      componentName: "MazPhoneNumberInput",
      instance: re,
      providedId: c.id
    }), j = h(), K = h(), S = Ye({
      start: 0,
      end: 0,
      cursorAtEnd: !0
    }), N = h(!1), O = h(!1), R = f(() => U(c.countryLocale, c.customCountriesList)), T = f(() => {
      var o;
      return (o = R.value) == null ? void 0 : o.filter((d) => {
        var e;
        return !((e = c.ignoredCountries) != null && e.includes(d.iso2));
      });
    }), _ = f(() => {
      const o = c.onlyCountries || c.preferredCountries;
      return o == null ? void 0 : o.map(
        (d) => {
          var e;
          return (e = T.value) == null ? void 0 : e.find((n) => n.iso2.includes(d));
        }
      );
    }), M = f(() => {
      var o;
      return (o = T.value) == null ? void 0 : o.filter((d) => {
        var e;
        return !((e = c.preferredCountries) != null && e.includes(d.iso2));
      });
    }), ee = f(() => c.preferredCountries ? [..._.value ?? [], ...M.value ?? []] : c.onlyCountries ? _.value : T.value), oe = f(() => {
      var o;
      return (o = ee.value) == null ? void 0 : o.map((d) => d ? {
        ...d,
        dialCode: `+${d.dialCode}`
      } : void 0).filter(Ne);
    }), w = f(() => ({
      ...Ze,
      ...c.translations
    })), G = f(() => {
      if (c.placeholder)
        return c.placeholder;
      const o = w.value.phoneInput.placeholder;
      if (c.noExample || !N.value)
        return o;
      {
        const d = t(b.value);
        return I.value.isValid || !d ? o : `${w.value.phoneInput.example} ${d}`;
      }
    }), Q = h(
      c.countryCode || c.defaultCountryCode
    );
    ce(
      () => c.countryCode || c.defaultCountryCode,
      (o) => {
        Q.value = o;
      }
    );
    const b = f({
      get: () => Q.value,
      set: (o) => {
        m("country-code", o), m("update:country-code", o), o && (he(o), me(z.value));
      }
    }), B = f({
      get: () => c.modelValue || c.defaultPhoneNumber,
      set: (o) => {
        m("update:model-value", o);
      }
    }), l = h(B.value);
    ce(
      () => c.modelValue || c.defaultPhoneNumber,
      (o) => {
        l.value = o;
      }
    );
    const g = h(), z = f(() => c.noFormattingAsYouType ? l.value ?? "" : g.value ?? l.value ?? ""), I = h(
      $({
        phoneNumber: B.value,
        countryCode: b.value
      })
    );
    async function F() {
      const o = await a();
      o && le(o);
    }
    async function te() {
      try {
        !c.noExample && !N.value && (await A(), N.value = !0);
      } catch {
        console.error("[maz-ui](MazPhoneNumberInput) while loading phone number examples file");
      }
    }
    Ee(async () => {
      await ye(B.value), await x(), c.fetchCountry && !b.value && await F(), !c.defaultCountryCode && !c.noUseBrowserLocale && !b.value && J(), await te();
    }), ce(
      () => I.value,
      (o) => {
        m("update", o), m("data", o);
      },
      { immediate: !0, deep: !0 }
    ), ce(
      () => B.value,
      async (o, d) => {
        o !== d && ye(o);
      }
    ), ce(
      () => z.value,
      async (o, d) => {
        if (!c.noFormattingAsYouType && o && o !== d) {
          const e = ie();
          if (e && !I.value.isValid && typeof S.start == "number" && !S.cursorAtEnd) {
            const n = S.start, r = S.end;
            setTimeout(() => {
              e.setSelectionRange(n, r ?? n);
            }, 0);
          }
        }
      }
    );
    function J() {
      const { locale: o } = L();
      o && le(o);
    }
    function se(o, d) {
      I.value = $({
        phoneNumber: o,
        countryCode: d
      });
    }
    async function me(o) {
      const d = ie();
      S.start = d == null ? void 0 : d.selectionStart, S.end = d == null ? void 0 : d.selectionEnd, S.cursorAtEnd = S.start ? S.start >= o.length : !0;
      const e = P(o);
      l.value = e;
      const n = $({
        phoneNumber: e,
        countryCode: b.value
      });
      B.value = n.e164;
    }
    function he(o) {
      le(o, !0), se(z.value, o);
    }
    function le(o, d = !1) {
      try {
        ro(o) && (Q.value = o, d && de());
      } catch (e) {
        console.error(`[maz-ui](MazPhoneNumberInput) ${e}`);
      }
    }
    async function ye(o) {
      se(o, b.value), await x(), c.noFormattingAsYouType ? l.value = z.value : o ? g.value = S.cursorAtEnd || I.value.isValid ? l.value = W(
        I.value.countryCode ?? b.value,
        I.value.formatNational ?? l.value
      ) : l.value : g.value = void 0, await x(), ve(I.value);
    }
    function ve(o) {
      o.countryCode && b.value !== o.countryCode && le(o.countryCode);
    }
    function ie() {
      var o;
      return (o = j.value) == null ? void 0 : o.$el.querySelector("input");
    }
    function be() {
      var o, d;
      (d = (o = K.value) == null ? void 0 : o.$el.querySelector("input")) == null || d.focus();
    }
    async function de() {
      var o;
      await x(), (o = ie()) == null || o.focus();
    }
    return (o, d) => {
      var e, n, r, i;
      return v(), k("div", {
        id: V(ue),
        class: E(["m-phone-number-input", [
          c.class,
          {
            "--no-flags": o.noFlags
          }
        ]]),
        style: ae(o.style)
      }, [
        b.value && !o.noFlags && !o.noCountrySelector ? (v(), k(
          "button",
          {
            key: 0,
            class: E(["m-phone-number-input__country-flag maz-text-xl", {
              "--should-have-bottom-flag": w.value.countrySelector.placeholder.length > 0
            }]),
            tabindex: "-1",
            type: "button",
            onClick: be
          },
          [
            y(`
        @slot Country selector flag
          @binding {String} country-code - current selected country code - Ex: \`"FR"\`
      `),
            Y(o.$slots, "selector-flag", { countryCode: b.value }, () => [
              Ce(
                X(V(Ke)(b.value)),
                1
                /* TEXT */
              )
            ], !0)
          ],
          2
          /* CLASS */
        )) : y("v-if", !0),
        o.noCountrySelector ? y("v-if", !0) : (v(), D(So, {
          key: 1,
          ref_key: "CountrySelector",
          ref: K,
          modelValue: b.value,
          "onUpdate:modelValue": d[0] || (d[0] = (p) => b.value = p),
          class: "m-phone-number-input__select",
          "option-value-key": "iso2",
          "option-label-key": "name",
          "option-input-value-key": o.countrySelectorDisplayName ? "name" : "dialCode",
          "max-list-width": 250,
          disabled: o.disabled,
          color: o.color,
          size: o.size,
          "list-position": o.listPosition,
          search: !o.noSearch,
          "search-placeholder": w.value.countrySelector.searchPlaceholder,
          options: oe.value,
          error: o.error || (o.noValidationError ? !1 : !!z.value && !b.value),
          hint: z.value && !b.value ? w.value.countrySelector.error : void 0,
          success: o.success || (o.noValidationSuccess ? !1 : (e = I.value) == null ? void 0 : e.isValid),
          label: w.value.countrySelector.placeholder,
          style: ae({
            width: o.countrySelectorWidth
          }),
          onFocus: d[1] || (d[1] = (p) => O.value = !1)
        }, {
          default: fe(({ option: p, isSelected: C }) => [
            q(
              "div",
              {
                class: E(["m-phone-number-input__select__item maz-flex maz-items-center maz-gap-1 maz-truncate", {
                  "m-phone-number-input__select__item--selected": C
                }])
              },
              [
                !o.noFlags && typeof p.iso2 == "string" ? (v(), k("span", Po, [
                  y(`
              @slot Country list flag
                @binding {String} country-code - country code of option - Ex: \`"FR"\`
                @binding {{ iso2: string; dialCode: string; name: string; }} option - country data
                @binding {Boolean} is-selected - \`true\` if option is selected
            `),
                  Y(o.$slots, "country-list-flag", {
                    countryCode: p.iso2,
                    option: p,
                    isSelected: C
                  }, () => [
                    Ce(
                      X(V(Ke)(p.iso2)),
                      1
                      /* TEXT */
                    )
                  ], !0)
                ])) : y("v-if", !0),
                o.showCodeOnList ? (v(), k(
                  "span",
                  {
                    key: 1,
                    class: E(["maz-w-9 maz-flex-none", { "maz-text-muted": !C }])
                  },
                  X(p.dialCode),
                  3
                  /* TEXT, CLASS */
                )) : y("v-if", !0),
                q(
                  "span",
                  {
                    class: E(["maz-flex-1 maz-truncate", { "maz-font-semibold": C }])
                  },
                  X(p.name),
                  3
                  /* TEXT, CLASS */
                )
              ],
              2
              /* CLASS */
            )
          ]),
          _: 3
          /* FORWARDED */
        }, 8, ["modelValue", "option-input-value-key", "disabled", "color", "size", "list-position", "search", "search-placeholder", "options", "error", "hint", "success", "label", "style"])),
        Z(Ie, $e({
          id: o.id,
          ref_key: "PhoneNumberInput",
          ref: j,
          "model-value": z.value,
          label: G.value,
          disabled: o.disabled,
          color: o.color,
          error: o.error || (o.noValidationError ? !1 : !!z.value && !((n = I.value) != null && n.isValid))
        }, o.$attrs, {
          size: o.size,
          "icon-name": "phone",
          type: "tel",
          clearable: "",
          inputmode: "tel",
          success: o.success || (o.noValidationSuccess ? !1 : (r = I.value) == null ? void 0 : r.isValid),
          class: ["m-phone-number-input__input maz-flex-1", {
            "--border-radius": !o.noCountrySelector,
            "--error": o.error || !((i = I.value) != null && i.isValid),
            "--focused": O.value
          }],
          onFocus: d[2] || (d[2] = (p) => O.value = !0),
          onBlur: d[3] || (d[3] = (p) => O.value = !1),
          "onUpdate:modelValue": d[4] || (d[4] = (p) => me(p))
        }), null, 16, ["id", "model-value", "label", "disabled", "color", "error", "size", "success", "class"])
      ], 14, $o);
    };
  }
}), Ko = /* @__PURE__ */ Ae(Ao, [["__scopeId", "data-v-3bb3ee5f"]]);
export {
  Ko as M,
  Ae as _,
  Pe as u
};
